//@flow
import * as React from 'react';
import { FormGroup } from 'reactstrap';
import FormInput from './../../components/Inputs/FormInput';
import CpfCnpjInput from './../../components/Inputs/CpfCnpjInput';
import { isSudo } from '../../helpers/permissions.helper';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import { clienteService } from '../../services/cliente.service';

type Props = { onChangeText: any, entity: any, onChangeValue: any };

export default class UsuarioCrudListFilter extends React.PureComponent<Props> {
  render() {
    const { entity } = this.props;
    return (
      <React.Fragment>
        {isSudo() && (
          <FormGroup className="col-12 col-xl-3">
            <FormSelectInput
              name="cliente"
              id="cliente"
              label="Cliente"
              placeholder="Selecione o cliente"
              valueKey="codigoCliente"
              labelKey="label"
              required={true}
              returnFullObject={true}
              service={clienteService.findAll}
              onChange={(name, value) => {
                console.log(value);

                this.props.onChangeDate(name, value);
              }}
              value={entity.cliente}
            />
          </FormGroup>
        )}
        <FormGroup className="col-12 col-xl-3">
          <FormInput
            label="Nome do usuário"
            placeholder={'Nome'}
            id={'namefilter'}
            name="nome"
            onChange={this.props.onChangeDate}
            type={'text'}
            size={12}
            value={entity.nome}
          />
        </FormGroup>
        <FormGroup className="col-12 col-xl-3">
          <CpfCnpjInput
            label="CPF"
            type="text"
            id={'cpf'}
            name="cpf"
            size={100}
            placeholder="Digite o CPF ou CNPJ"
            value={entity.cpf}
            onChange={this.props.onChangeDate}
          />
        </FormGroup>
      </React.Fragment>
    );
  }
}
